import ApiConfig from "../Config";
import apiService from "../services/apiService";

const authService = {
  adminIdLogin: (email, password) =>
    apiService.post(ApiConfig.adminlogin, { email, password }),

  createGuestToken: () => apiService.post(ApiConfig.guestToken, {}),

  renewToken: (token) =>
    apiService.post(
      ApiConfig.renewToken,
      {},
      {
        headers: {
          "x-access-token": token,
        },
      },
    ),
};

export default authService;
